/*
 * @Author: cc
 * @LastEditTime: 2021-06-09 10:58:44
 */
import ReactDOM from 'react-dom';
import './index.css';
import 'antd/dist/reset.css'
import './App.css'
import App from './route/index'
import { Provider } from 'react-redux'
import store from './reducers/index'
import './css/base.scss';
import { watch, ranDomNum, IsPC } from "src/utils";
import { post, get } from "src/component/fetch"
import { CCvideoControlInstance } from "./component/video";
import { message } from 'antd';
import { Modal } from 'antd-mobile';
import { isInHarmonyOS } from './utils/web-call-app';
function getUserInfo() {
  post('/shop/front/ge/userInfo', {}, false).then(res => {
    store.dispatch({
      type: "SET_USER_INFO",
      ...res.data,
    })
  })
}

getUserInfo()
// getColumnDetail()
let newWindow = window as any
if(!isInHarmonyOS()){
  // CCvideoControlInstance.initVideo();
}
newWindow.onCCH5PlayerLoaded = () => {
  newWindow.ccH5PlayerJsLoaded = true;
};
// newWindow.on_player_volumechange = (volume: any, vid: any) => {
//   console.log("设置音量回调:  ", volume, vid);
// };
function getQueryUrl() {
  let url = window.location.href;
  let result: any = {};
  if (url.indexOf('?') > -1) {
    let str = url.split('?')[1];
    let temp = str.split('&');
    for (let i = 0; i < temp.length; i++) {
      let temp2 = temp[i].split('=');
      result[temp2[0]] = temp2[1]
    }
  }

  return result
}

/**CC视频开始播放
 * @param {video}视频信息
 * @param {vid} vid
 * @return {void}
 */
newWindow.on_CCH5player_play = (video: any, vid: any) => {
  const userInfo: any = store.getState().userInfo
  const videoStatus: any = store.getState().videoStatus
  if (!userInfo.userId) {
    window.ccPlayerStatus.pause();
    newWindow.isLogin()
  } else {
    if(videoStatus.runStatus && videoStatus.runStatus !== "进行中"){
      IsPC && message.error("课程不在开放时间内")
      !IsPC && Modal.alert({
        title: "提示",
        content:"课程不在开放时间内"
      })
      window.ccPlayerStatus.pause();
    }
    const { subjectId } = getQueryUrl()
    post('/shop/front/ge/getSubjectUserSignInfo', { subjectId }, false).then(res => {
      if (res.data.isSignUp) {
        clearInterval(newWindow["playing"] as any);
        watch();
        // 每30秒调用一次接口
        (newWindow["playing"] as any) = setInterval(() => {
          watch();
          // preventOpenMoreVideoFn("1");
        }, 30000);
      } else {
        window.ccPlayerStatus.pause();
        newWindow.isNeedAddBaseInfo()
      }
    })
  }
};
/**CC视频暂停
 * @param {any}
 * @param {vid} vid
 * @return {void}
 */
newWindow.on_CCH5player_pause = (video: any, vid: string) => {
  console.log("----暂停----");
  watch();
  ranDomNum.pause();
  // 清空30秒上传数据接口
  clearInterval(newWindow["playing"]);
  // preventOpenMoreVideoFn("0");
};
/**CC播放结束
 * @param {any}
 * @param {vid} vid
 * @return {void}
 */
newWindow.on_CCH5player_ended = (video: any, vid: string) => {
  console.log("----结束----", video, vid);
  newWindow.video_end()
  watch();
  // 清空随机数计时器
  ranDomNum.pause();
  // preventOpenMoreVideoFn("0");
  // 清空30秒上传数据接口
  clearInterval(newWindow["playing"]);
};
ReactDOM.render(
  <Provider store={store}><App /></Provider>,
  document.getElementById('root')
);